import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

export const useDashboardStyles = makeStyles({
  container: {
    padding: tokens.spacingHorizontalXL,
    backgroundColor: tokens.colorNeutralBackground2,
    minHeight: "100vh",
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    padding: tokens.spacingVerticalL,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    marginBottom: tokens.spacingVerticalL,
    boxShadow: tokens.shadow4,
  },
  cardTitle: {
    margin: `0 0 ${tokens.spacingVerticalM} 0`,
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    borderBottom: `2px solid ${tokens.colorBrandForeground1}`,
    paddingBottom: tokens.spacingVerticalS,
  },
  userInfo: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
  },
  userInfoItem: {
    display: "flex",
    gap: tokens.spacingHorizontalS,
  },
  userInfoLabel: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  configGrid: {
    display: "grid",
    gap: tokens.spacingVerticalM,
  },
  configItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  configLabel: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
  },
  configValue: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
  },
  primaryButton: {
    width: "100%",
    marginTop: tokens.spacingVerticalM,
  },
  successMessage: {
    marginTop: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground1,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: tokens.fontSizeBase300,
    textAlign: "center",
  },
  errorMessage: {
    marginTop: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorPaletteRedBackground2,
    color: tokens.colorPaletteRedForeground1,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: tokens.fontSizeBase300,
    textAlign: "center",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "200px",
  },
});
